import React from "react";
import { motion } from "framer-motion";

function InlineText({ text }) {
  return String(text || "").split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={index} className="font-semibold">{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}

function MessageContent({ content }) {
  const lines = String(content || "").split("\n");
  return lines.map((line, index) => {
    const trimmed = line.trim();
    const listMatch = trimmed.match(/^[-*]\s+(.+)/);
    if (listMatch) {
      return (
        <div key={index} className="flex gap-2 pl-1">
          <span aria-hidden="true" className="text-current/55">•</span>
          <span><InlineText text={listMatch[1]} /></span>
        </div>
      );
    }
    return <React.Fragment key={index}><InlineText text={line} />{index < lines.length - 1 && <br />}</React.Fragment>;
  });
}

export default function ChatBubble({ role, content }) {
  const isUser = role === "user";
  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.34, ease: [0.22, 1, 0.36, 1] }}
      className={`flex ${isUser ? "justify-end" : "justify-start"} taip-chat-row`}
    >
      <div
        data-testid={isUser ? "user-bubble" : "ai-bubble"}
        className={
          isUser
            ? "bg-[#123B8F] text-white rounded-3xl rounded-tr-md px-4 py-3 md:px-5 md:py-3.5 shadow-[0_6px_20px_rgba(18,59,143,0.2)] max-w-[88%] sm:max-w-[72%] whitespace-pre-wrap text-[15px] sm:text-base leading-relaxed"
            : "bg-white text-[#172033] rounded-3xl rounded-tl-md px-4 py-3 md:px-5 md:py-3.5 shadow-[0_7px_26px_rgba(10,37,64,0.07)] border border-[#E8ECF3] max-w-[88%] sm:max-w-[76%] whitespace-pre-wrap text-[15px] sm:text-base leading-relaxed"
        }
      >
        <MessageContent content={content} />
      </div>
    </motion.div>
  );
}
